<template>
  <a-layout class="password-reset">
    <TitleBreadcrumb />
    <div class="content-base container">
      <a-row type="flex" justify="center" :gutter="[16, 16]">
        <a-col :md="12">
          <RequestPasswordResetForm />
        </a-col>
      </a-row>
    </div>
  </a-layout>
</template>
<script>
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import RequestPasswordResetForm from "@/components/RequestPasswordResetForm.vue";
import store from "@/store";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "../../utils/utils";
import labels from "@/utils/labels";
export default {
  components: { TitleBreadcrumb, RequestPasswordResetForm },
  name: "PasswordReset",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.adminPasswordResetForm.subtitle),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.adminPasswordResetForm.subtitle,
      },
    ],
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state?.clientAuth?.authenticated) next();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.password-reset {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    min-height: auto;
  }
  .content-base {
    padding-top: 60px;
    @media screen and (max-width: $screen-mobile) {
      padding-top: 50px;
      max-width: 100% !important;
    }
  }
}
</style>
